import Router, { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'src/store/store';
import { resetWritePage, setIsEdited } from 'src/modules/community/write/actions';

type Props = { unsavedChanges: boolean; onAccept?: () => void; isSubmitted?: boolean }

export const useUnsavedChangesPrompt = ({ unsavedChanges, onAccept, isSubmitted }: Props) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const isEditPostOrPollPage = router.pathname.includes('/community/write');

  const handleBeforeUnload = useCallback((event: BeforeUnloadEvent) => {
    if (isSubmitted) return;
    event.preventDefault();
  }, [isSubmitted]);

  const routeChangeStart = useCallback(() => {
    if (isSubmitted) return;
    if (confirm('You have unsaved changes that will be lost if you leave this page. Are you sure you want to leave?')) {
      onAccept?.();
      dispatch(resetWritePage());
    } else {
      Router.events.emit('routeChangeError');
      throw ('Unsaved changes. Route change blocked.'); // doesn't work with return, the blocker is the thrown exception.
    }
  }, [isSubmitted, onAccept, dispatch]);

  useEffect(() => {
    if (!unsavedChanges) return;
    if (isEditPostOrPollPage) dispatch(setIsEdited());

    window.addEventListener('beforeunload', handleBeforeUnload);
    Router.events.on('routeChangeStart', routeChangeStart);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      Router.events.off('routeChangeStart', routeChangeStart);
    };
  }, [dispatch, isEditPostOrPollPage, unsavedChanges, handleBeforeUnload, routeChangeStart]);
};
